export const CHECK_IF_DATA_EXSISTS = "checkIfDataExists";
export const GET_FLIGHTS = "getFlights";
export const GET_ABOUT_TEXT = "getAboutText";
export const GET_STORIES_TEXT = "getStoriesText";
export const GET_ZONES = "getZones";
